import stateManager from '../../../../modules/user/stateManager';
import analytics from '../../../../modules/analytics';
import { LAST_SHOWN_KEY } from './constants';
import { openModal as openProductSalesModal } from './ProductSalesEducationModal';

let isChecking = false;

// eslint-disable-next-line
export const markProductSalesAnnouncementAsRead = () => stateManager.addAction(LAST_SHOWN_KEY, Date.now());

/**
 * Handler that watches for the notification that triggers the product sales education modal.
 * @param {Array} notifications List of all notifications for current user
 * @param {Object} modalContext Info required to mount a modal
 */
export const onReceiveNotifications = async (notifications, modalContext) => {
  const productSalesNotification = notifications.find(
    n => n.type === 'product_sales_education',
  );
  if (productSalesNotification && !isChecking) {
    isChecking = true;
    const lastShown = await stateManager.getActionValue(LAST_SHOWN_KEY);
    isChecking = false;
    if (!lastShown) {
      const { provider_id: providerId } = productSalesNotification;
      analytics.track('product_sales_education_modal_first_launch_view');
      markProductSalesAnnouncementAsRead();
      return openProductSalesModal(modalContext, { providerId });
    }
  }
  return null;
};
